/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import styles from "ui/feature/piece-original-images/PieceOriginalImage.module.scss"
import {
    PieceOriginalImage_sheet$data
} from "ui/feature/piece-original-images/__generated__/PieceOriginalImage_sheet.graphql";

interface Props {
    sheet: PieceOriginalImage_sheet$data
}

const PieceOriginalImage: React.FC<Props> = ({sheet}) => {
    return (
        <div>
            <img className={styles.image} src={sheet.download_url} alt={"Sheet Music Page"}/>
        </div>
    )
}

export default createFragmentContainer(PieceOriginalImage, {
    page: graphql`
    fragment PieceOriginalImage_sheet on MusicSheet {
        id
        download_url
    }`
});
